// extracted by mini-css-extract-plugin
module.exports = {"widget":"MultipleSearchLayout_widget__3dz4B","mainWrapper":"MultipleSearchLayout_mainWrapper__2wcXC"};